const asyncActionType = type => ({
    pending: `${type}_PENDING`,
    success: `${type}_SUCCESS`,
    error: `${type}_ERROR`
});

export const FETCH_SMS_SAFE_PROMOT = asyncActionType('FETCH_SMS_SAFETY_PROMOTIONS');
export const GET_EVENTS_MEETINGS = asyncActionType('GET_EVENTS_MEETINGS');
export const FETCH_DEFAULT_TILES = asyncActionType('FETCH_DEFAULT_TILES');
